<template>
	<NewItem
		ref="newItem"
		button-title="Add New Output"
	>
		<template slot="form">
			<OutputNewForm
				@close="close"
			/>
		</template>
	</NewItem>
</template>

<script>
import NewItem from '@/components/NewItem';
import OutputNewForm from '@/components/Report/OutputNewForm';

export default {
	components: {
		NewItem,
		OutputNewForm,
	},
	methods: {
		close() {
			this.$refs.newItem.close();
		},
	},
};
</script>
